import React from 'react';
import { Box, Typography } from '@mui/material';
import { HelpOutline as QuestionIcon } from '@mui/icons-material';
import ShareDialog from '../ShareDialog';
import { shareCustomQuestion, getQuestionShares } from '../../../services/custom-tab-sharing.service';

const ShareCustomQuestionDialog = ({
    open,
    onClose,
    customQuestion,
    onShareSuccess
}) => {
    const handleShare = async (customQuestionId, selectedUsers, message) => {
        return await shareCustomQuestion(customQuestionId, selectedUsers, message);
    };

    const handleLoadShares = async (customQuestionId) => {
        return await getQuestionShares(customQuestionId);
    };

    const renderItemInfo = (item, existingShares) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <QuestionIcon sx={{ color: '#2196f3' }} />
            <Typography variant="body1" sx={{ color: '#333333', fontSize: '0.9rem' }}>
                Share "{item?.label || item?.title || 'this custom question'}" with team members
            </Typography>
        </Box>
    );

    return (
        <ShareDialog
            open={open}
            onClose={onClose}
            title="Share Custom Question"
            item={customQuestion}
            itemType="CUSTOM_QUESTION"
            onShare={handleShare}
            onLoadShares={handleLoadShares}
            renderItemInfo={renderItemInfo}
            shareButtonText="Share"
            allowUniversal={false} // Questions don't support universal access
            onShareSuccess={onShareSuccess}
        />
    );
};

export default ShareCustomQuestionDialog;

